import { render } from "./ShouRuBuPinPage.vue?vue&type=template&id=096f6f79&scoped=true"
import script from "./ShouRuBuPinPage.vue?vue&type=script&lang=js"
export * from "./ShouRuBuPinPage.vue?vue&type=script&lang=js"

import "./ShouRuBuPinPage.vue?vue&type=style&index=0&id=096f6f79&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096f6f79"]])

export default __exports__